<template>
  <Loading :loading="!loading_is_complete"></Loading>
  <Products v-if="loading_is_complete" />
</template>

<script>
import Loading from "../components/Loading";
import Products from "../components/Product/List";

export default {
  name: "Group",
  components: { Loading, Products },
  beforeMount() {
    this.$store.dispatch(
      "group_info/FETCH_GROUP",
      this.$route.params.group_slug
    );
  },
  mounted() {},
  updated() {
    this.ppJs.popup_catalog.hide_popup_catalog();
    // if (this.group) {
    //   document.title = this.group.name;
    //   if (document.querySelector('meta[name="description"]') !== null)
    //     document
    //       .querySelector('meta[name="description"]')
    //       .setAttribute("content", this.group.meta_description);

    //   if (document.querySelector('meta[name="title"]') !== null)
    //     document
    //       .querySelector('meta[name="title"]')
    //       .setAttribute("content", this.group.meta_title);
    // }

    //console.log('компонент Group обновился')
  },
  computed: {
    loading_is_complete() {
      return this.$store.getters["group_info/GET_LOADING_IS_COMPLETE"];
    },
    group() {
      return this.$store.getters["group_info/GET_GROUP_INFO"];
    },
  },
};
</script>
